import { Injectable } from '@angular/core';
import { ApplicationSettings } from 'projects/lib_config/src/public-api';
import { AuthenticationService } from 'projects/lib_authentication/src/public-api';
import { ScriptInjectorService } from 'projects/lib_util/src/public-api';

declare const _satellite: any;

declare global {
  interface Window {
    digitalData: any;
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private userId: string;

  constructor(
    private scriptInjectorService: ScriptInjectorService,
    private appSettings: ApplicationSettings,
    private authenticationService: AuthenticationService) { }

  initAdobeLaunchDataLayer() {
    this.initializeDataLayer();

    try {
      this.authenticationService.getAuthenticadedUserObservable().subscribe(user => {
        if (user?.preferredUsername) {
          const isInternalUser = user.preferredUsername.toLocaleLowerCase().endsWith('@deloitte.com');
          this.userId = user.preferredUsername.split('@')[0];
          this.initializeDataLayer(isInternalUser ? this.userId : '');
          console.info('Analytics data layer initiated..');
        }
      });
    } catch (error) {
      console.error('Error while initializing analytics data', error);
    }
  }

  private initializeDataLayer(userName: string = '') {
    window.digitalData = {
      page: {
        pageInfo: { pageName: 'page_name' },
        category: { primaryCategory: 'site_section' }
      },
      user: [{
        profile: [{
          profileInfo: { userName }
        }]
      }]
    };
  }

  async injectAdobeLaunchScript() {
    try {
      await this.scriptInjectorService.load('launch', this.appSettings.analyticsScriptSrc);
      _satellite.pageBottom();
      console.info('Analytics script loaded..');
    } catch (error) {
      console.error('Error while loading analytics script', error);
    }
  }

  trackPage(section: string, name: string) {
    if (this.appSettings.enableAnalytics) {
      try {
        if (!window.digitalData?.page?.pageInfo || !window.digitalData?.page?.category) {
          this.initializeDataLayer();
        }
        window.digitalData.page.pageInfo.pageName = name;
        window.digitalData.page.category.primaryCategory = section;
        _satellite.track('page_load');
      } catch (error) {
        console.error('Error while calling analytics tracking', error);
      }
    }
  }
}